<form [formGroup]="form">
  <div class="row">
    <!-- label -->
    <div class="col-6">
      <div class="form-group">
        <label class="bmd-label-floating" for="label">Label</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="emailFooter.label"
          name="label"
          formControlName="label"
        />
        <wm-control-message
          [control]="form.controls['label']"
        ></wm-control-message>
      </div>
    </div>

    <div class="col-2"></div>

    <!-- enabled slider -->
    <div class="col-2 text-center">
      <div class="row">
        <div class="col">
          Enabled
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="switch">
            <label>
              <input
                id="isEnabled"
                type="checkbox"
                [(ngModel)]="emailFooter.isEnabled"
                formControlName="enabled"
              />
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="col-2"></div>
  </div>

  <!-- full email footer -->
  <div class="row mt-5">
    <div class="col">
      <label class="bmd-label-floating p-2" for="htmlContent">Content</label>
      <ckeditor
        #htmlContentEditor
        [editor]="Editor"
        [config]="editorConfig"
        formControlName="htmlContent"
        [(ngModel)]="emailFooter.htmlContent"
        (ready)="editorReady($event)"
      ></ckeditor>
      <wm-control-message
        [control]="form.controls['htmlContent']"
      ></wm-control-message>
    </div>
  </div>
</form>
